import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import users from '../../../../users';
import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

const toLower = text => {
  return text.toString().toLowerCase()
}

const searchBookByText = (items, term) => {
  if (term != '') {
    return items.filter(item => toLower(item.text).includes(toLower(term)));
  }

  return items
}

export default {
  name: 'positionInWalkRoute',
  mixins: [users, validationMixin],
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: [],
      lang: '',

      permanentMessages: [],
      permanentMessage: '',
      accessMessages: [],
      accessMessage: '',
      book: '',
      walk: 0,
      previousConnection: '',
      tagNumber: '',
      locationCode: '',
      locationDescription: '',
      captureCoordinates: false,
      captureGPSCoordinates: false,
      x: 0,
      y: 0,
      accuracy: '',
      xgps: 0,
      ygps: 0,
      gpsAccuracy: '',
      connectionId: 0,
      previousConnectionId: 0,

      showBookWalkDialog: false,

      active: 'first',
      first: false,
      second: false,
      books: [],
      walks: [],
      selectedBook: '',
      selectedWalk: '',
      selectedWalkId: '',
      firstStepError: null,
      propertyConnections: [],
      propertyConnectionsCount: 0,
      propertyConnectionsCols: [],
      keyColumn: 'connectionId',

      newConnectionId: 0,
      connData: {},
      searchBook: '',
      searchedBooks: [],
      walksToDisplay: [],
    }
  },
  validations: {
    book: {
      required
    },
    walk: {
      required
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('position_in_walk_route_updated', this.init);
    this.fillPropertyConnectionsCols();
    this.init();
  },
  watch: {
    searchBook: {
      handler: function (val) {
        if (this.searchBook == '') {
          this.searchedBooks = this.books;
          return;
        }

        this.searchedBooks = searchBookByText(this.books, this.searchBook);
      },
      deep: true
    },
    accessMessage: function (val) {
      this.dataObj.appData.accessMessage = val;
    },
    permanentMessage: function (val) {
      this.dataObj.appData.permanentMessage = val;
    },
    locationDescription: function (val) {
      this.dataObj.appData.locationDescription = val;
    },
    locationCode: function (val) {
      this.dataObj.appData.locationCode = val;
    },
    //previousConnection: function (val) {
    //  this.dataObj.appData.previousConnection = val;
    //},
    newConnectionId: function (val) {
      this.dataObj.appData.previousConnectionId = val;
    },
    book: function (val) {
      this.dataObj.appData.book = val;
    },
    walk: function (val) {
      this.dataObj.appData.walk = val;
    },
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;

        this.fillFields(this.appData);
      });
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    validateAppData() {
      this.$v.$touch();


      if (this.book == null || this.book == '') {
        this.$alertMsg(this.$t('activities.bookError'));
        return;
      }
      if (this.walk == null || this.walk < 0 ) {
        this.$alertMsg(this.$t('activities.walkError'));
        return;
      }
      if (this.previousConnection == null || this.previousConnection < 0) {
        this.$alertMsg(this.$t('activities.previousConnectionError'));
        return;
      }

      //console.log(this.$v);

      if (!this.$v.$invalid) {
        return true;
      }
      else {
        return false;
      }
    },
    fillFields(data) {
      //console.log(data);
      this.permanentMessage = data.permanentMessage;
      this.permanentMessages = data.permanentMessages;
      this.accessMessage = data.accessMessage;
      this.accessMessages = data.accessMessages;
      this.book = data.book;
      this.walk = data.walk;
      this.previousConnection = data.previousConnection;
      this.tagNumber = data.tagNumber;
      this.locationCode = data.locationCode;
      this.locationDescription = data.locationDescription;
      this.captureCoordinates = data.captureCoordinates;
      this.captureGPSCoordinates = data.captureGPSCoordinates;
      this.x = data.x;
      this.y = data.y;
      this.accuracy = data.accuracy;
      this.xgps = data.xgps;
      this.ygps = data.ygps;
      this.gpsAccuracy = data.gpsAccuracy;
      this.connectionId = data.connectionId;
      this.previousConnectionId = data.previousConnectionId;
    },
    getBooksWalks() {
      this.active = 'first';
      this.searchBook = '';

      if (this.books.length > 0) {
        this.showBookWalkDialog = true;
        return;
      }

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/LocateConnectionActivity/GetBooksWalks', parameter),
        response => {
          if (response.status == 200) {
            this.showBookWalkDialog = true;
            this.selectedBook = '';
            this.selectedWalk = '';
            this.selectedWalkId = '';

          }
          this.books = response.data.item.books.sort((a, b) => (a.value > b.value) ? 1 : (a.value < b.value) ? -1 : 0);
          this.walks = response.data.item.walks.sort((a, b) => (a.value > b.value) ? 1 : (a.value < b.value) ? -1 : 0);
          this.searchedBooks = this.books;

          //this.selectedWalk = this.walks.length == 0 ? '' : this.walks[0].value;
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    getClass(item, isBook) {
      if (isBook && item.value == this.selectedBook || !isBook && item.value == this.selectedWalkId)
        return 'selected-button'
    },
    selectBook(book) {
      this.selectedBook = book.value;
      this.selectedWalk = '';
      this.selectedWalkId = '';
      let selBook = this.books.filter(b => b.text == book.text)
      if (selBook != null && selBook.length > 0) {
          this.walksToDisplay = this.walks.slice(0, selBook[0].noWalks);
      }
    },
    selectWalk(walk) {
      this.selectedWalk = walk.text;
      this.selectedWalkId = walk.value;
    },
    chooseBookWalk() {
      if (this.selectedBook === '' || this.selectedWalkId === '') {
        this.firstStepError = this.$t('activities.selectBookWalkError')
        return;
      }

      this.firstStepError = null;
      this.active = 'second';
      this.getPropertyConnections();
    },
    getPropertyConnections() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Book: this.selectedBook,
        Walk: this.selectedWalkId
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/LocateConnectionActivity/GetPropertyConnections', parameter),
        response => {
          if (response.status == 200) {
            this.propertyConnections = response.data.items;
            this.propertyConnectionsCount = response.data.itemsCount;

            if (this.propertyConnectionsCount == 0) {
              this.$alertMsg(this.$t('captureMR.noDataFound'), 3);
              this.active = 'first';
            }
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    fillPropertyConnectionsCols() {
      this.propertyConnectionsCols.push({ dataField: 'propertyRef', caption: this.$t('activities.propertyRef') });
      this.propertyConnectionsCols.push({ dataField: 'connNo', caption: this.$t('activities.connection') });
      this.propertyConnectionsCols.push({ dataField: 'status', caption: this.$t('activities.status') });
      this.propertyConnectionsCols.push({ dataField: 'meter', caption: this.$t('activities.meter') });
      this.propertyConnectionsCols.push({ dataField: 'address', caption: this.$t('activities.address') });
      this.propertyConnectionsCols.push({ dataField: 'custkey', caption: this.$t('activities.Account') });
    },
    onSelectPropertyConnection(info) {
      if ((info === null) || (info === undefined))
        return false;

      this.newConnectionId = info.data.connectionId;
      this.setConnectionData();
    },
    onChoosePropertyConnection(info) {
      if ((info === null) || (info === undefined))
        return false;

      //console.log(info);
      this.newConnectionId = info.rows[info.newRowIndex].data.connectionId;
      //console.log(this.newConnectionId);
      return true;
    },
    setConnectionData() {

      this.getGeoLocation();

      var connData = {
        connectionId: this.connectionId,
        book: this.selectedBook,
        walk: Number(this.selectedWalkId),
        previousConnectionId: this.newConnectionId,
        previousConnection: '',
        tagNumber: this.tagNumber,
        locationCode: this.locationCode,
        locationDescription: this.locationDescription,
        permanentMessage: this.permanentMessage,
        accessMessage: this.accessMessage,
        captureGPSCoordinates: this.captureGPSCoordinates,
        captureCoordinates: this.captureCoordinates//,
        //xgps: this.xgps,
        //ygps: this.ygps,
        //gpsAccuracy: this.gpsAccuracy,
        //x: this.x,
        //y: this.y,
        //accuracy: this.accuracy
      };

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(connData))
      };

      //console.log(parameter);

      this.$store.state.notifier.asyncBlock(
        axios.post('/LocateConnectionActivity/SetConnectionData', parameter),
        response => {
          if (response.status == 200)
            this.fillFields(response.data.item);
          this.showBookWalkDialog = false;
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    getGeoLocation() {
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          //console.log(pos);
          if (this.captureCoordinates) {
            this.x = pos.coords.latitude;
            this.y = pos.coords.longitude;
            this.accuracy = pos.coords.accuracy;
          }

          if (this.captureGPSCoordinates) {
            this.xgps = pos.coords.latitude;
            this.ygps = pos.coords.longitude;
            this.gpsAccuracy = pos.coords.accuracy;
          }
        },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );
    }
  },
}
